import ValueDisplay from "./value-display";
import type { RenderProps } from "./types";

export default function duiNitRenderer({
  value,
  isOldValue,
  obj,
}: RenderProps) {
  if (obj.config?.allow_select_document_type) {
    if (typeof value === "string" && value !== "") {
      const label =
        obj.config.document_type === "passport"
          ? "PASAPORTE"
          : obj.config.document_type.toUpperCase();
      return (
        <ValueDisplay isOldValue={isOldValue}>
          ({label}){value}
        </ValueDisplay>
      );
    }
  }

  if (typeof value === "string" && value !== "") {
    return <ValueDisplay isOldValue={isOldValue}>{value}</ValueDisplay>;
  }

  const duiNITValue = value as { type: string; value: string } | undefined;
  if (!duiNITValue?.value) {
    return <span className="text-on-disabled-quiet">Vacío</span>;
  }
  const label =
    duiNITValue.type === "passport"
      ? "PASAPORTE"
      : duiNITValue.type.toUpperCase();
  return (
    <ValueDisplay isOldValue={isOldValue}>
      ({label})&nbsp;{duiNITValue.value}
    </ValueDisplay>
  );
}
